import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import classNames from 'classnames';

// Having this called in the rendering of the component is not good for performance
// If we experience performance issues in the future, implement using
// a class method on a regular component class
// i.e. handledOnClick() { wrapHandler(this.props.onClick) }
function wrapHandler(h) {
  return (e) => {
    if (h) h();
    e.preventDefault();
    e.stopPropagation();
  };
}

const Card = ({ header, onClick, maxPerRow = 2, selected = false, children }) => (
  <Col
    className='card-setting'
    lg={12 / Math.min(maxPerRow, 3)}
    md={12 / Math.min(maxPerRow, 2)}
    sm={12}
  >
    {header && (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className={classNames({ 'card-header': true, selected })} onClick={wrapHandler(onClick)}>
        {header}
      </div>)
    }
    <Col
      md={12}
      className={classNames({ 'card-well': true, 'with-header': header, selected })}
      onClick={wrapHandler(onClick)}
    >
      {children}
    </Col>
  </Col>
);

export default Card;

Card.propTypes = {
  onClick: PropTypes.func,
  header: PropTypes.element,
  maxPerRow: PropTypes.number,
  selected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
